import ErrorBoundaryReactRouterV6 from "Containers/ErrorBoundaryReactRouterV6";
import { onboard, withAuth } from "Helpers/withAuth";
import AuthPage from "Pages/AuthPage";
import GroupsList from "Pages/GroupsList";
import GroupsOverlap from "Pages/GroupsOverlap";
import Home from "Pages/Home";
import ImportFattureInCloud from "Pages/ImportFattureInCloud";
import ImportLanding from "Pages/ImportLanding";
import ImportStatus from "Pages/ImportStatus";
import NoAuthPage from "Pages/NoAuthPage";
import ProfileBounce from "Pages/ProfileBounce";
import ProfileClick from "Pages/ProfileClick";
import ProfileTrend from "Pages/ProfileTrend";
import RecipientsList from "Pages/RecipientsList";
import RecipientsOverview from "Pages/RecipientsOverview";
import UnsubscriptionCampaignsList from "Pages/UnsubscriptionCampaignsList";
import * as Sentry from "@sentry/react";
import { sessionId, useSessionCheck } from "mailup-react-helpers";
import { PageHeader } from "mailup-web-components";
import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { RecoilRoot } from "recoil";
import ErrorBoundary from "./containers/ErrorBoundary";
import Locale from "./containers/Locale";
import ImportWizard from "Pages/ImportWizard";

const NoMatchPage = () => {
  return (
    <>
      <PageHeader breadcrumbsItems={[]} />

      <div className="l-container" data-mu-test="no-match-page" />
    </>
  );
};

const router = Sentry.wrapCreateBrowserRouter(createBrowserRouter)(
  [
    {
      path: "/",
      Component: Home,
      ErrorBoundary: ErrorBoundaryReactRouterV6,
      children: [
        {
          path: "/auth",
          Component: AuthPage,
        },
        {
          path: "/recipients/list",
          Component: withAuth(
            RecipientsList,
            NoAuthPage,
            "uo:NL OR uo:SMS",
            onboard,
          ),
        },

        {
          path: "/recipients/import",
          Component: withAuth(ImportLanding, NoAuthPage, "", onboard),
        },
        {
          path: "/recipients/import/status",
          Component: withAuth(ImportStatus, NoAuthPage, "", onboard),
        },
        {
          path: "/recipients/import/:type",
          Component: withAuth(ImportWizard, NoAuthPage, "", onboard),
        },
        {
          path: "/recipients/import-fatture-in-cloud",
          Component: withAuth(ImportFattureInCloud, NoAuthPage, "", onboard),
        },
        {
          path: "/recipients/profile/:idRecipient/trend",
          Component: withAuth(
            ProfileTrend,
            NoAuthPage,
            "NOT uo:PRIVACYBLOCK",
            onboard,
          ),
        },
        {
          path: "/recipients/profile/:idRecipient/click",
          Component: withAuth(
            ProfileClick,
            NoAuthPage,
            "NOT uo:PRIVACYBLOCK",
            onboard,
          ),
        },
        {
          path: "/recipients/profile/:idRecipient/bounce",
          Component: withAuth(
            ProfileBounce,
            NoAuthPage,
            "NOT uo:PRIVACYBLOCK",
            onboard,
          ),
        },
        {
          path: "/recipients/unsubscriptioncampaigns/list",
          Component: withAuth(
            UnsubscriptionCampaignsList,
            NoAuthPage,
            "uo:NL",
            onboard,
          ),
        },
        {
          path: "/recipients/overview",
          Component: withAuth(RecipientsOverview, NoAuthPage, "", onboard),
        },
        {
          path: "/recipients/groups/list",
          Component: withAuth(GroupsList, NoAuthPage, "uo:GROUP", onboard),
        },
        {
          path: "/recipients/groups/overlap",
          Component: withAuth(GroupsOverlap, NoAuthPage, "", onboard),
        },
        {
          path: "/*",
          Component: NoMatchPage,
        },
      ],
    },
  ],
  { basename: `/${sessionId}` },
);

const App = () => {
  useSessionCheck("recipients_app_redirector.aspx?r=/recipients/list");

  return (
    <RecoilRoot>
      <ErrorBoundary>
        <Locale>
          <RouterProvider router={router} />
        </Locale>
      </ErrorBoundary>
    </RecoilRoot>
  );
};

export default App;
